// extracted by mini-css-extract-plugin
module.exports = {"select":"o38qFymIvRb5tb6nFLXdn","icon":"K78Sd_HBAEP04EKGvLiuM"};